 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth~business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-g~3de3c4e1":"auth~business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-g~3de3c4e1","auth":"auth","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-gatewa~2039e368":"business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-gatewa~2039e368","create-pos-gateway-report~deposit-transaction-details~deposit-transactions-table~refund-transactions~669faf8c":"create-pos-gateway-report~deposit-transaction-details~deposit-transactions-table~refund-transactions~669faf8c","create-pos-gateway-report":"create-pos-gateway-report","create-web-gateway-report":"create-web-gateway-report","panel-layout~transactions-list~user-profile":"panel-layout~transactions-list~user-profile","transactions-list":"transactions-list","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-web-gatewa~f5a47a11":"business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-web-gatewa~f5a47a11","account-info~business-details~change-password~create-business~create-gateway~create-pos-gateway~crea~98784235":"account-info~business-details~change-password~create-business~create-gateway~create-pos-gateway~crea~98784235","business-details":"business-details","create-business":"create-business","create-gateway":"create-gateway","create-pos-gateway":"create-pos-gateway","create-web-gateway":"create-web-gateway","dashboard-widgets":"dashboard-widgets","pos-gateway-settings":"pos-gateway-settings","web-gateway-settings":"web-gateway-settings","withdrawal":"withdrawal","login-form~password-recovery~register-form":"login-form~password-recovery~register-form","login-form":"login-form","password-recovery":"password-recovery","register-form":"register-form","register-verification~reset-password-otp~succeed-registration":"register-verification~reset-password-otp~succeed-registration","register-verification":"register-verification","reset-password-otp":"reset-password-otp","reset-password":"reset-password","businesses-list":"businesses-list","deposit-transaction-details":"deposit-transaction-details","user-profile":"user-profile","refund-transaction-details":"refund-transaction-details","withdrawal-transaction-details":"withdrawal-transaction-details","deposit-transactions-table~panel-layout~refund-transactions-table~withdrawal-transactions-table":"deposit-transactions-table~panel-layout~refund-transactions-table~withdrawal-transactions-table","panel-layout":"panel-layout","succeed-registration":"succeed-registration","login":"login","register":"register","businesses":"businesses","dashboard":"dashboard","transactions":"transactions","deposit-transactions-table":"deposit-transactions-table","refund-transactions-table":"refund-transactions-table","withdrawal-transactions-table":"withdrawal-transactions-table","account-info":"account-info","change-password":"change-password","accept-modal":"accept-modal","refund-modal":"refund-modal"}[chunkId]||chunkId) + "." + {"auth~business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-g~3de3c4e1":"dfbba75d","auth":"e0fb7c98","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-gatewa~2039e368":"348e13dc","create-pos-gateway-report~deposit-transaction-details~deposit-transactions-table~refund-transactions~669faf8c":"31587f2f","create-pos-gateway-report":"f2f615bf","create-web-gateway-report":"94cc854a","panel-layout~transactions-list~user-profile":"40bc9bac","transactions-list":"c660c515","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-web-gatewa~f5a47a11":"f43e2723","account-info~business-details~change-password~create-business~create-gateway~create-pos-gateway~crea~98784235":"0fb60717","business-details":"11ba5cca","create-business":"b3728376","create-gateway":"ac0e697b","create-pos-gateway":"86837e04","create-web-gateway":"a840d60e","dashboard-widgets":"3079ed40","pos-gateway-settings":"8e4a7d9a","web-gateway-settings":"ca7cd37a","withdrawal":"7935ed5b","login-form~password-recovery~register-form":"57915138","login-form":"9f8150fc","password-recovery":"52970db0","register-form":"6d422d0d","register-verification~reset-password-otp~succeed-registration":"ae1dcbe5","register-verification":"6c6c3daa","reset-password-otp":"07589bb3","reset-password":"afa824a7","businesses-list":"a32b1335","deposit-transaction-details":"92ba0c6d","user-profile":"9e99bcd9","refund-transaction-details":"6a8d411f","withdrawal-transaction-details":"a4c4fd10","deposit-transactions-table~panel-layout~refund-transactions-table~withdrawal-transactions-table":"58c1dd4c","panel-layout":"692c790f","succeed-registration":"9953e597","login":"521cc51c","register":"1ee94ec3","businesses":"3f31cf6a","dashboard":"c391adf0","transactions":"029140f7","deposit-transactions-table":"c75db3f5","refund-transactions-table":"cb49f8da","withdrawal-transactions-table":"78c5b1bc","account-info":"66824e60","change-password":"c31c9b1b","accept-modal":"cc58feab","refund-modal":"a705c089"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth~business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-g~3de3c4e1":1,"auth":1,"business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-gatewa~2039e368":1,"create-pos-gateway-report~deposit-transaction-details~deposit-transactions-table~refund-transactions~669faf8c":1,"create-pos-gateway-report":1,"create-web-gateway-report":1,"panel-layout~transactions-list~user-profile":1,"transactions-list":1,"account-info~business-details~change-password~create-business~create-gateway~create-pos-gateway~crea~98784235":1,"business-details":1,"create-business":1,"create-gateway":1,"create-pos-gateway":1,"create-web-gateway":1,"dashboard-widgets":1,"pos-gateway-settings":1,"web-gateway-settings":1,"withdrawal":1,"login-form~password-recovery~register-form":1,"login-form":1,"password-recovery":1,"register-form":1,"register-verification~reset-password-otp~succeed-registration":1,"register-verification":1,"reset-password-otp":1,"reset-password":1,"businesses-list":1,"deposit-transaction-details":1,"user-profile":1,"refund-transaction-details":1,"withdrawal-transaction-details":1,"deposit-transactions-table~panel-layout~refund-transactions-table~withdrawal-transactions-table":1,"panel-layout":1,"succeed-registration":1,"login":1,"register":1,"businesses":1,"transactions":1,"deposit-transactions-table":1,"refund-transactions-table":1,"withdrawal-transactions-table":1,"account-info":1,"change-password":1,"refund-modal":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth~business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-g~3de3c4e1":"auth~business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-g~3de3c4e1","auth":"auth","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-gatewa~2039e368":"business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-gatewa~2039e368","create-pos-gateway-report~deposit-transaction-details~deposit-transactions-table~refund-transactions~669faf8c":"create-pos-gateway-report~deposit-transaction-details~deposit-transactions-table~refund-transactions~669faf8c","create-pos-gateway-report":"create-pos-gateway-report","create-web-gateway-report":"create-web-gateway-report","panel-layout~transactions-list~user-profile":"panel-layout~transactions-list~user-profile","transactions-list":"transactions-list","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-web-gatewa~f5a47a11":"business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-web-gatewa~f5a47a11","account-info~business-details~change-password~create-business~create-gateway~create-pos-gateway~crea~98784235":"account-info~business-details~change-password~create-business~create-gateway~create-pos-gateway~crea~98784235","business-details":"business-details","create-business":"create-business","create-gateway":"create-gateway","create-pos-gateway":"create-pos-gateway","create-web-gateway":"create-web-gateway","dashboard-widgets":"dashboard-widgets","pos-gateway-settings":"pos-gateway-settings","web-gateway-settings":"web-gateway-settings","withdrawal":"withdrawal","login-form~password-recovery~register-form":"login-form~password-recovery~register-form","login-form":"login-form","password-recovery":"password-recovery","register-form":"register-form","register-verification~reset-password-otp~succeed-registration":"register-verification~reset-password-otp~succeed-registration","register-verification":"register-verification","reset-password-otp":"reset-password-otp","reset-password":"reset-password","businesses-list":"businesses-list","deposit-transaction-details":"deposit-transaction-details","user-profile":"user-profile","refund-transaction-details":"refund-transaction-details","withdrawal-transaction-details":"withdrawal-transaction-details","deposit-transactions-table~panel-layout~refund-transactions-table~withdrawal-transactions-table":"deposit-transactions-table~panel-layout~refund-transactions-table~withdrawal-transactions-table","panel-layout":"panel-layout","succeed-registration":"succeed-registration","login":"login","register":"register","businesses":"businesses","dashboard":"dashboard","transactions":"transactions","deposit-transactions-table":"deposit-transactions-table","refund-transactions-table":"refund-transactions-table","withdrawal-transactions-table":"withdrawal-transactions-table","account-info":"account-info","change-password":"change-password","accept-modal":"accept-modal","refund-modal":"refund-modal"}[chunkId]||chunkId) + "." + {"auth~business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-g~3de3c4e1":"f9ffeafd","auth":"a6d10393","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-pos-gatewa~2039e368":"e170d5fe","create-pos-gateway-report~deposit-transaction-details~deposit-transactions-table~refund-transactions~669faf8c":"4eb0deb2","create-pos-gateway-report":"65359c7c","create-web-gateway-report":"6d19c86d","panel-layout~transactions-list~user-profile":"0da7d1bb","transactions-list":"c70f348e","business-details~businesses-list~create-business~create-gateway~create-pos-gateway~create-web-gatewa~f5a47a11":"31d6cfe0","account-info~business-details~change-password~create-business~create-gateway~create-pos-gateway~crea~98784235":"645d578a","business-details":"9cc5446b","create-business":"0675b17d","create-gateway":"21dba707","create-pos-gateway":"3f7ea199","create-web-gateway":"c5bd8f0c","dashboard-widgets":"89223a8a","pos-gateway-settings":"93bb28ab","web-gateway-settings":"d7b60349","withdrawal":"e6c37f93","login-form~password-recovery~register-form":"1b119b2c","login-form":"0e433876","password-recovery":"0e433876","register-form":"e79bf004","register-verification~reset-password-otp~succeed-registration":"712d8707","register-verification":"b7db25bc","reset-password-otp":"0e433876","reset-password":"87db9942","businesses-list":"68549f24","deposit-transaction-details":"0170c223","user-profile":"740b944c","refund-transaction-details":"a0277c7e","withdrawal-transaction-details":"e9c2e3bd","deposit-transactions-table~panel-layout~refund-transactions-table~withdrawal-transactions-table":"f8369342","panel-layout":"177af6e9","succeed-registration":"2704e423","login":"0e433876","register":"0e433876","businesses":"0e433876","dashboard":"31d6cfe0","transactions":"0e433876","deposit-transactions-table":"914f2e73","refund-transactions-table":"f9e7948c","withdrawal-transactions-table":"f9e7948c","account-info":"0b58d184","change-password":"8b67397b","accept-modal":"31d6cfe0","refund-modal":"ecf8f88c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
